import { MDBBtn, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import React from "react";
import { Link } from "react-router-dom";

const UnderConstruction = () => (
  <MDBContainer>
    <MDBRow>
      <div className="col-12">
        <section className="my-5 text-center">
          <h2 className="display-1">we are building  the feature</h2>

          <h4 className="mb-4">Please provide your feedback </h4>

          <p className="mb-0">
            feature details
          </p>
          <p className="mb-4">
            more details
          </p>
          <Link to="/home">
            <MDBBtn>home</MDBBtn>
          </Link>
        </section>
      </div>
    </MDBRow>
  </MDBContainer>
);

export default UnderConstruction;
